export interface IHotWordsRes {
  words: Array<string>;
  enhanceEnable: boolean;
}


export interface ISaveSpeechDraftReq {
  originStreamName: string;
  reportFileKey: string;
  controllerStatus: number;
  reportFileName: string;
  reportFirstSentence: string;
}

export enum ControllerStatus {
  // 完成
  COMPLETED = 1,
  // 待录制
  PENDING = 2,
  // 正在录制
  RECORDING = 3,
}

export interface IControlStartedBoardReq {
  originStreamName: string;
  boardStreamName: string;
  controllerStatus: ControllerStatus;
  boardSn?: string; // 设备序列号（可选）
}

export interface IControlUnStartBoardReq {
  originStreamName: string;
  controllerStatus: ControllerStatus;
  boardSn?: string; // 设备序列号（可选）
}

export enum ControlHandle {
  REBOOT = "REBOOT",
  LINk_JOIN = "LINk_JOIN",
  TIPS_JOIN = "TIPS_JOIN",
}